/**
 * index.tsx
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { FC, useId, useMemo, MouseEvent, createElement } from 'react';
import { useField }                       from 'formik';
import { TypeSelectProps }                from './types';
import { types }                          from './const';
import { styles }                         from './styles';

export const TypeSelect: FC<TypeSelectProps> = ({ name, ...props }) => {
  const childId = useId();
  const [field, meta] = useField({ name });
  const handleTypeClick = (ev: MouseEvent<HTMLButtonElement>, value: string) => {
    ev.stopPropagation();
    ev.preventDefault();
    field.onChange({ target: { name, value } });
  }

  const typeChilds = useMemo(() => types.map(({ icon, value, label }) => (
    <button type="button" key={`${childId}-${value}`} css={[styles.type, field.value === value && styles.active]} onClick={e => handleTypeClick(e, value)} >
      {createElement(icon)}
      <span>{label}</span>
    </button>
  )), [types, field.value])

  return (
    <div css={styles.container}>
      <input {...field} type="hidden" />
      <div css={styles.types}>
        {typeChilds}
      </div>
    </div>
  );
};